module.exports = __webpack_public_path__ + "images/super-sad-outlinefb6af3694fb9c0c1fc584731fd22f283.svg";